import React, { useEffect, useState } from "react";
import Logo from "./components/Logo/Logo";
import Profile from "./components/Profile/Profile";
import Menu from "./components/Menu/Menu";
import CampaignButton from "../CampaignButton";
import { useLocation } from "react-router-dom";
import { RoutesE } from "../../routes/routesData";

import styles from "./header.module.scss";

/**
 * Top bar component
 */

const Header = () => {
  const { pathname } = useLocation();
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  useEffect(() => {
    setIsMenuVisible(
      pathname !== RoutesE.LOGIN && pathname !== RoutesE.FORGOT_PASSWORD
    );
  }, [pathname]);

  const isMobileDevice = window.innerWidth < 992;
  return (
    <header className={styles.container} data-no-print>
      <div className={styles.logoWrapper}>
        <Logo className={styles.logo} />
      </div>
      <div className={styles.menuWrapper}>{isMenuVisible && <Menu />}</div>
      <div className={styles.profileWrapper}>
        {!isMobileDevice && <CampaignButton hideTextOnMobile id="header" />}
        <Profile />
      </div>
    </header>
  );
};

export default Header;
